import React from "react";
import { TimestampToDateMoment } from "../../../../../utils/timestampToDate";
import { StyledBreakWord } from "../../../../styles/styledBreakWord";
import { StyledCol, StyledTableRow } from "../../../../styles/styledTable";

const ClientItem = ({ key, value }) => {

  return (
    <>
      <StyledTableRow
        key={key}
        scroll="auto"
        col="5"
        className="client-table__row"
      >
        <StyledCol>
          {value.nickname ?? "--"}
        </StyledCol>
        <StyledCol>
          {value.firstname ?? "--"}
        </StyledCol>
        <StyledCol>
          {value.lastname ?? "--"}
        </StyledCol>
        <StyledCol inline>
          <StyledBreakWord as="p">
            {value.email}
          </StyledBreakWord>
        </StyledCol>
        <StyledCol>
          {TimestampToDateMoment(value.createDate)}
        </StyledCol>
      </StyledTableRow>
    </>
  );
};
export default ClientItem;